import script from "./Step2.vue?vue&type=script&setup=true&lang=ts"
export * from "./Step2.vue?vue&type=script&setup=true&lang=ts"

import "./Step2.vue?vue&type=style&index=0&id=3d24a611&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d24a611"]])

export default __exports__